/* tslint:disable */
/* eslint-disable */
/**
 * Careplatform Invite API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * Contact: jonas.malik@magello.se
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface VerifyInviteCodeResponse
 */
export interface VerifyInviteCodeResponse {
    /**
     * UUID of the authenticated user
     * @type {string}
     * @memberof VerifyInviteCodeResponse
     */
    userId: string;
    /**
     * Access token to use for authentication
     * @type {string}
     * @memberof VerifyInviteCodeResponse
     */
    token: string;
}

export function VerifyInviteCodeResponseFromJSON(json: any): VerifyInviteCodeResponse {
    return VerifyInviteCodeResponseFromJSONTyped(json, false);
}

export function VerifyInviteCodeResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): VerifyInviteCodeResponse {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'userId': json['userId'],
        'token': json['token'],
    };
}

export function VerifyInviteCodeResponseToJSON(value?: VerifyInviteCodeResponse | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'userId': value.userId,
        'token': value.token,
    };
}


